import React from 'react';
import { Trash2 } from 'lucide-react';
import { Category } from '../types';

interface CategoryBarProps {
  categories: Category[];
  selectedCategory?: string;
  onCategoryChange: (category: string | undefined) => void;
  onDeleteCategory?: (category: Category) => void;
  onOpenFilter?: () => void;
  isAdmin?: boolean;
}

const CategoryBar: React.FC<CategoryBarProps> = ({
  categories,
  selectedCategory,
  onCategoryChange,
  onDeleteCategory,
  onOpenFilter,
  isAdmin,
}) => {
  const showFilter = categories.length > 10;
  const displayedCategories = showFilter ? categories.slice(0, 9) : categories;

  return (
    <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
      <button
        onClick={() => onCategoryChange(undefined)}
        className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
          !selectedCategory
            ? 'bg-purple-600 text-white'
            : 'bg-dark-700 text-dark-200 hover:bg-dark-600 hover:text-dark-100'
        }`}
      >
        Todos
      </button>

      {categories.length === 0 && (
        <span className="px-2 py-2 text-sm text-dark-400">Nenhuma categoria disponível.</span>
      )}

      {displayedCategories
        .filter(cat => cat.name !== 'Todos')
        .map((category) => (
          <div
            key={category.id}
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
              selectedCategory === category.name
                ? 'bg-purple-600 text-white'
                : 'bg-dark-700 text-dark-200 hover:bg-dark-600 hover:text-dark-100'
            }`}
            role="button"
            tabIndex={0}
            onClick={() => onCategoryChange(category.name)}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                onCategoryChange(category.name);
              }
            }}
          >
            <span>{category.name}</span>
            {isAdmin &&
  onDeleteCategory &&
  category.name !== 'Todos' && (
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onDeleteCategory(category);
                }}
                className="rounded-full p-1 bg-dark-800 text-dark-200 hover:bg-red-600 hover:text-white transition-colors"
                aria-label={`Excluir categoria ${category.name}`}
              >
                <Trash2 size={14} />
              </button>
            )}
          </div>
        ))}
      {showFilter && onOpenFilter && (
        <button
          type="button"
          onClick={onOpenFilter}
          className="px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap bg-dark-700 text-dark-200 hover:bg-dark-600 hover:text-dark-100 transition-colors"
        >
          Filtrar
        </button>
      )}
    </div>
  );
};

export default CategoryBar;
